import { render } from "./AppFooter.vue?vue&type=template&id=6c81c0cf&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import "./AppFooter.vue?vue&type=style&index=0&id=6c81c0cf&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c81c0cf"]])

export default __exports__